import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import { AdministrationServicePath, CLINICS } from "../../../utils/constants";
import ListClinic from "./List";
import CreateClinic from "./Create";
import EditClinic from "./Edit";
import ShowClinic from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <CalendarViewWeekIcon />,
  name: AdministrationServicePath + CLINICS,
  title: "Клиники",
  list: <ListClinic />,
  create: <CreateClinic />,
  createPermission: permissions.canManageClinics,
  edit: <EditClinic />,
  editPermission: permissions.canManageClinics,
  show: <ShowClinic />,
  showPermission: permissions.canPreviewClinics,
  permission: permissions.canPreviewClinics,
};
